module.exports = __webpack_public_path__ + "img/ic-sort-dn.b22b9d25.svg";